<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-form title="EMPRESAS DO USUÁRIO" :rota="{name: 'usuarioRead'}" tooltip="Lista de Usuários" />

            <md-card-content>
                <div class="md-layout">
                    <div class="md-layout-item md-size-100 md-xsmall-size-100">
                        <md-tabs class="md-info mdTabs">
                            <md-tab v-if="permissoes.usuarioRemoveEmpresa" id="tab-niveis" md-label="Empresas" md-icon="business">
                                <md-table v-model="searchedDelete" md-card @md-selected="selectDelete" md-fixed-header>
                                    <md-table-toolbar>
                                        <div class="md-toolbar-section-start"></div>
                                        <md-field md-clearable class="md-toolbar-section-end">
                                            <md-input placeholder="Pesquise aqui por empresa ou grupo de empresas" v-model="search" @input="searchOnTableEmpresaUsuario" />
                                        </md-field>
                                    </md-table-toolbar>

                                    <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple" md-auto-select class="tableRow">
                                        <md-table-cell style="width: 5%" md-numeric>{{ item.id }}</md-table-cell>
                                        <md-table-cell class="uppercase" style="width: 50%">{{ item.razao_social }}</md-table-cell>
                                        <md-table-cell class="uppercase" style="width: 45%">{{ item.grupo }}</md-table-cell>
                                    </md-table-row>
                                </md-table>
                                <md-card-actions class="cardActions">
                                    <div class="md-toolbar-section-start">
                                        <h3 class="uppercase text-secondary"><strong>{{ usuario.nome }}</strong></h3>
                                    </div>
                                    <md-button @click="removePermissoes" class="md-danger md-round">
                                        <span class="md-label">
                                            <md-icon class="material-icons">delete</md-icon>
                                        </span>EXCLUIR
                                    </md-button>
                                </md-card-actions>
                            </md-tab>

                            <md-tab v-if="permissoes.usuarioAddEmpresa" id="tab-add-niveis" md-label="Adicionar Empresas" md-icon="add">
                                <md-table v-model="searchedAdd" md-card @md-selected="selectAdd" md-fixed-header>
                                    <md-table-toolbar>
                                        <div class="md-toolbar-section-start"></div>
                                        <md-field md-clearable class="md-toolbar-section-end">
                                            <md-input placeholder="Pesquise aqui por empresa ou grupo de empresas" v-model="search" @input="searchOnTableEmpresa" />
                                        </md-field>
                                    </md-table-toolbar>

                                    <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple" md-auto-select class="tableRow">
                                        <md-table-cell md-label="ID" style="width: 5%" md-sort-by='id' md-numeric>{{ item.id }}</md-table-cell>
                                        <md-table-cell class="uppercase" md-label="NOME" style="width: 50%" md-sort-by="razao_social">{{ item.razao_social }}</md-table-cell>
                                        <md-table-cell class="uppercase" md-label="DESCRIÇÃO" style="width: 45%" md-sort-by="grupo">{{ item.grupo }}</md-table-cell>
                                    </md-table-row>
                                </md-table>
                                <md-card-actions class="cardActions">
                                    <div class="md-toolbar-section-start">
                                        <h3 class="uppercase text-secondary"><strong>{{ usuario.nome }}</strong></h3>
                                    </div>
                                    <md-button @click="adicionarEmpresas" class="md-success md-round">
                                        <span class="md-label">
                                            <md-icon class="material-icons">add</md-icon>
                                        </span>ADICIONAR
                                    </md-button>
                                </md-card-actions>
                            </md-tab>
                        </md-tabs>
                    </div>
                </div>
            </md-card-content>

        </md-card>
    </div>
</div>
</template>

<script>
import Notify from '@/config/mixins/notify'
import preLoader from '@/config/mixins/preLoader';
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'

const toLower = text => {
    return text.toString().toLowerCase()
}

const searchByName = (items, term) => {
    if (term) {
        return items.filter(item => toLower([item.razao_social, item.grupo]).includes(toLower(term)))
    }

    return items
}

export default {
    name: 'UsuarioReadEmpresa',
    components: {
        HeaderForm
    },

    mixins: [Notify, preLoader],

    data() {
        return {
            dados: {},
            usuario: {},
            permissoes: this.$store.state.usuario.permissao,
            usuarioEmpresas: [],
            empresas: [],
            deleteEmpresa: [],
            addEmpresa: [],
            search: null,
            searchedDelete: [],
            searchedAdd: []
        };
    },

    created() {
        this.getEmpresa()
        this.searchedDelete = this.usuarioEmpresas
        this.searchedAdd = this.empresas
    },

    methods: {
        getEmpresa() {
            this.$http.get(this.$urlAPI + 'usuarios/empresa/' + this.$route.params.id)
                .then(response => {
                    if (response.data.status) {
                        this.usuario = response.data.usuario;
                        this.usuarioEmpresas = response.data.dados;
                        this.empresas = response.data.empresas;
                        this.searchedDelete = response.data.dados
                        this.searchedAdd = response.data.empresas
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        searchOnTableEmpresaUsuario() {
            this.searchedDelete = searchByName(this.usuarioEmpresas, this.search)
        },

        searchOnTableEmpresa() {
            this.searchedAdd = searchByName(this.empresas, this.search)
        },

        selectDelete(items) {
            let item = []
            items.forEach(element => {
                item.push(element.id)
            });
            this.deleteEmpresa = item
        },

        selectAdd(items) {
            let item = []
            items.forEach(element => {
                item.push(element.id)
            });
            this.addEmpresa = item
        },

        removePermissoes() {
            if (this.deleteEmpresa.length === 0) {
                return this.warning('Selecione pelo menos uma Permissão antes de excluir!')
            }
            this.dados.id = this.usuario.id
            this.dados.empresas = this.deleteEmpresa
            this.$http.post(this.$urlAPI + 'usuarios/remove_empresa', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.usuario = response.data.usuario;
                        this.usuarioEmpresas = response.data.dados;
                        this.empresas = response.data.empresas;
                        this.searchedDelete = response.data.dados
                        this.searchedAdd = response.data.empresas
                        this.success(response.data.message)
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        adicionarEmpresas() {
            if (this.addEmpresa.length === 0) {
                return this.warning('Selecione pelo menos uma Empresa antes de adicionar!')
            }
            this.dados.id = this.usuario.id
            this.dados.empresas = this.addEmpresa
            this.$http.post(this.$urlAPI + 'usuarios/empresa', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.usuario = response.data.usuario;
                        this.usuarioEmpresas = response.data.dados;
                        this.empresas = response.data.empresas;
                        this.searchedDelete = response.data.dados
                        this.searchedAdd = response.data.empresas
                        this.success(response.data.message)
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        }
    },
}
</script>

<style lang="scss" scoped>
.md-tab {
    margin-top: -50px !important;
}

.mdTabs {
    margin-top: 30px;
}
</style>
